import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { ExpandMore } from '@mui/icons-material';
import Form from './form';

interface AccordionInterestedPeopleProps {
  disabled?: boolean;
}

const AccordionInterestedPeopleComponent = ({
  disabled = false,
}: AccordionInterestedPeopleProps): React.ReactElement => {
  const [open, setOpen] = useState(false);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="accordion-interested-people-content"
        id="accordion-interested-people-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>Persone interessate dalla pratica</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Form disabled={disabled} />
      </AccordionDetails>
    </Accordion>
  );
};

AccordionInterestedPeopleComponent.displayName =
  'Practice Detail - Form - accordion interested people';

const AccordionInterestedPeople = memo(AccordionInterestedPeopleComponent);

export default AccordionInterestedPeople;
